import { ApolloError } from '@apollo/client';

import { Stack } from '@mui/material';

import { LocationFragment, MembershipFragment, PhoneNumberMetadataFragment } from '@occc/graphql';
import { IEaivMembershipStatistics } from '@occc-app/dataAccessLayer/eaiv/types';
import config from '@occc/config';

import MemberDetails from './MemberDetails';
import AudienceDetails from './AudienceDetails';
import CommunicationPreferences from './communication-preferences';
import { Statistics } from './Statistics';
import { Comments } from './Comments/comments.component';

type MemberContentProps = {
  toggleUpdatePointsModal: () => void;
  toggleCreateCommentModal: () => void;
  member: MembershipFragment;
  memberError?: ApolloError;
  locations?: LocationFragment[];
  locationsError?: ApolloError;
  locationsLoading: boolean;
  eaivStatistics: IEaivMembershipStatistics;
  isPointsAdjustmentEnabled: boolean;
  isUserPermittedToEdit: boolean;
  phoneNumberMetadata?: PhoneNumberMetadataFragment;
  isPhoneNumberMetadataLoading: boolean;
  isPhoneNumberMetadataError?: ApolloError;
};

export const MemberContent = (props: MemberContentProps) => {
  const {
    toggleUpdatePointsModal,
    toggleCreateCommentModal,
    member,
    locations,
    locationsLoading,
    locationsError,
    isPointsAdjustmentEnabled,
    eaivStatistics,
    isUserPermittedToEdit,
    phoneNumberMetadata,
    isPhoneNumberMetadataLoading,
    isPhoneNumberMetadataError,
  } = props;

  return (
    <Stack spacing={1}>
      <MemberDetails
        member={member}
        locations={locations}
        locationsLoading={locationsLoading}
        locationsError={locationsError}
        phoneNumberMetadata={phoneNumberMetadata}
        isPhoneNumberMetadataLoading={isPhoneNumberMetadataLoading}
        isPhoneNumberMetadataError={isPhoneNumberMetadataError}
      />
      <Statistics
        member={member}
        isPointsAdjustmentEnabled={isPointsAdjustmentEnabled}
        isUserPermittedToEditMemberPoints={isUserPermittedToEdit}
        toggleUpdatePointsModal={toggleUpdatePointsModal}
      />
      <AudienceDetails
        fuelAndConvenienceProfile={member?.fuelAndConvenienceProfile ?? undefined}
        eaivStatistics={eaivStatistics}
        externalIdentityVerificationProfiles={member.externalIdentityVerificationProfiles ?? []}
      />
      {member?.customerUuid && config.communicationPreference.enabled && (
        <CommunicationPreferences
          customerUuid={member.customerUuid}
          phoneNumber={member.phone}
          isUserPermittedToEdit={isUserPermittedToEdit}
        />
      )}
      <Comments
        membershipId={member.id}
        onCreateCommentClick={toggleCreateCommentModal}
        customerUuid={member.customerUuid || null}
      />
    </Stack>
  );
};
